define([
    'jquery',
    'jquery.lazyload',
    'ps/sentry'
], function(
    $
){
    $(document).ready(function() {
        $('img.lazy-load').lazyload({
            effect : "fadeIn",
            threshold : 100
        });
        $('img.lazy-load:visible').lazyload({
            effect : "fadeIn",
            threshold : 100
        });
        $("img.lazy-load:hidden").lazyload({
            effect : "fadeIn",
            threshold : 100,
            event : "lazyLoadShowHidden"
        });

        // Run Lazyload on start
        $(window).resize();
    });
});
